// extracted by mini-css-extract-plugin
export default {"arrowIcon":"tiltedArrowIcon_arrowIcon__jjglk"};